export default __webpack_public_path__ + "static/media/onyeani.7cbac8e3.png";